import ReportDelayDeliveryInstruction from '@/models/ReportDelayDeliveryInstruction/ReportDelayDeliveryInstruction';

export default class ReportDelayDeliveryInstructionFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.filterCustomerId = '';
		this.filterDestinationId = '';
		this.filterDiNumber = '';
		this.filterPoNoCustomer = '';
		this.filterPartId = '';
		this.tempId = '';
		this.customerName = '';
		this.destinationName = '';
		this.diNumber = '';
		this.poNoCustomer = '';
		this.diDeliveryDateFrom = '';
		this.diDeliveryDateTo = '';
		this.partNumber = '';
		this.partName = '';
		this.qtyDelivery = '';
		this.qtyActualSupply = '';
		this.qtyOutstanding = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			filterCustomerId : '0',
			filterDestinationId : '0',
			filterDiNumber : '0',
			filterPoNoCustomer : '0',
			filterPartId : '0',
			tempId : '0',
			customerName : '0',
			destinationName : '0',
			diNumber : '0',
			poNoCustomer : '0',
			diDeliveryDateFrom : '0',
			diDeliveryDateTo : '0',
			partNumber : '0',
			partName : '0',
			qtyDelivery : '0',
			qtyActualSupply : '0',
			qtyOutstanding : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}